import { Navigate, useLocation } from 'react-router-dom';
import { firstVisibleHousePath } from '@/application/navigation/menuHouses';
import { DashboardPage } from '@/presentation/pages/DashboardPage';
import { usePermissions } from '@/presentation/contexts/permissionsContextCore';

/** US-122: `/` solo muestra Resumen si hay `dashboard.view`; si no, primera casa del menú. */
export function HomeRoute() {
  const { hasPermission } = usePermissions();
  const location = useLocation();
  const home = firstVisibleHousePath(hasPermission) ?? '/';

  if (home !== '/') {
    return <Navigate to={{ pathname: home, search: location.search }} replace />;
  }

  if (!hasPermission('dashboard.view')) {
    return null;
  }

  return <DashboardPage />;
}
